export const keepFocus = fn => (...args) => {
  const activeElement = document.activeElement;
  return fn(...args).finally(() => activeElement.focus());
};
